var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.searchValue.length >= 1)?_c('Icon',{staticClass:"mt-3 cursor-pointer",attrs:{"name":"mdi-close","color":"black","size":"base"},nativeOn:{"click":function($event){_vm.searchValue = ''}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }